// Builds the monthly crescent announcement for 4 languages x 6 platforms.
const TZ = 'Asia/Riyadh';
const LOCALES = { ar: 'ar-EG', en: 'en-GB', id: 'id-ID', ur: 'ur-PK' };

const MONTHS_ID = ['Muharram', 'Safar', 'Rabiul Awal', 'Rabiul Akhir', 'Jumadil Awal', 'Jumadil Akhir',
  'Rajab', "Sya'ban", 'Ramadan', 'Syawal', 'Zulkaidah', 'Zulhijah'];
const MONTHS_UR = ['محرم', 'صفر', 'ربیع الاول', 'ربیع الثانی', 'جمادی الاول', 'جمادی الثانی',
  'رجب', 'شعبان', 'رمضان', 'شوال', 'ذوالقعدہ', 'ذوالحجہ'];

const VIS_NOTES = {
  easy: {
    ar: 'ويمكن رؤيته بسهولة بالعين المجردة', en: 'when it should be easily visible to the naked eye',
    id: 'dan mudah terlihat dengan mata telanjang', ur: 'اور اسے آسانی سے کھلی آنکھ سے دیکھا جا سکے گا',
  },
  possible: {
    ar: 'ويمكن رؤيته بالعين المجردة إذا كانت السماء صافية', en: 'when it may be seen with the naked eye in clear skies',
    id: 'dan dapat terlihat dengan mata telanjang jika langit cerah', ur: 'اور صاف آسمان میں اسے کھلی آنکھ سے دیکھا جا سکے گا',
  },
  difficult: {
    ar: 'وقد تكون رؤيته صعبة وتحتاج إلى أدوات بصرية', en: 'though sighting may be difficult and require optical aid',
    id: 'namun mungkin sulit dan memerlukan alat optik', ur: 'لیکن رویت مشکل ہو سکتی ہے اور دوربین کی ضرورت پڑ سکتی ہے',
  },
};

const T = {
  ar: {
    main: (d) => `🌙 بحسب الحسابات الفلكية الدقيقة لتطبيق «فلك»، تحدث بإذن الله ولادة هلال شهر ${d.month} ${d.year} هـ يوم ${d.conjDate}، الساعة ${d.conjTime} بتوقيت مكة المكرمة.`,
    vis: (d) => `وأول رؤية ممكنة للهلال في مكة المكرمة مساء ${d.visDate}، ${d.note}.`,
    first: (d) => `وعليه يكون ${d.firstDate} غرة ${d.month} وفق تقويم «فلك»، كما يوضح الفيديو المرفق.`,
    firstSplit: (d) => `وعليه يكون ${d.firstDate} غرة ${d.month} وفق تقويم «فلك» الحسابي، بينما يُتوقع أن تبدأ الغرة وفق الرؤية يوم ${d.sightFirst}، كما يوضح الفيديو المرفق.`,
    xSight: (d) => ` (ووفق الرؤية المتوقعة: ${d.sightShort})`,
    respect: 'مع احترامنا لما تعلنه الجهات الشرعية في كل بلد بناءً على الرؤية.',
    download: '📲 حمّل فلك:',
    bio: '📲 رابط التحميل في الملف الشخصي',
    pro: 'من نتائج محرّك الحسابات الفلكية في تطبيق «فلك»:',
    x: (d) => `🌙 ولادة هلال ${d.month} ${d.year} هـ: ${d.conjShort} الساعة ${d.conjTime} بتوقيت مكة.\nغرة الشهر وفق تقويم «فلك»: ${d.firstShort}${d.sightX}.\nوالعبرة بإعلان الجهات الرسمية في بلدك.`,
    ytTitle: (d) => `ولادة هلال ${d.month} ${d.year} هـ بتوقيت مكة | تطبيق فلك`,
    pinTitle: (d) => `موعد ولادة هلال ${d.month} ${d.year} هـ وغرة الشهر`,
    tags: (m) => ['#فلك', `#هلال_${m.replace(/\s+/g, '_')}`, '#التقويم_الهجري', '#علم_الفلك', '#الهلال'],
  },
  en: {
    main: (d) => `🌙 According to the precise astronomical calculations of the Falak app, the new crescent of ${d.month} ${d.year} AH will be born, God willing, on ${d.conjDate} at ${d.conjTime} Mecca time (${d.utcTime} GMT).`,
    vis: (d) => `The first possible sighting from Mecca is on the evening of ${d.visDate}, ${d.note}.`,
    first: (d) => `Accordingly, ${d.firstDate} will be the 1st of ${d.month} according to the Falak calendar, as shown in the attached video.`,
    firstSplit: (d) => `Accordingly, ${d.firstDate} is the 1st of ${d.month} in the calculated Falak calendar, while a sighting-based start is expected on ${d.sightFirst}, as shown in the attached video.`,
    xSight: (d) => ` (expected by sighting: ${d.sightShort})`,
    respect: 'We respect the official announcements of each country based on the moon sighting.',
    download: '📲 Get Falak:',
    bio: '📲 Download link in bio',
    pro: 'From the astronomical engine behind the Falak app:',
    x: (d) => `🌙 New crescent of ${d.month} ${d.year} AH: ${d.conjShort}, ${d.conjTime} Mecca time.\n1st of the month (Falak calendar): ${d.firstShort}${d.sightX}.\nPlease follow the official announcement in your country.`,
    ytTitle: (d) => `New Crescent of ${d.month} ${d.year} AH – Mecca Time | Falak App`,
    pinTitle: (d) => `${d.month} ${d.year} AH: new crescent date and 1st of the month`,
    tags: (m) => ['#Falak', `#${camel(m)}`, '#NewMoon', '#HijriCalendar', '#IslamicCalendar'],
  },
  id: {
    main: (d) => `🌙 Berdasarkan perhitungan astronomi yang akurat dari aplikasi Falak, insya Allah hilal bulan ${d.month} ${d.year} H akan lahir pada ${d.conjDate} ${d.conjTime} waktu Mekkah.`,
    vis: (d) => `Hilal paling awal dapat dilihat dari Mekkah pada petang ${d.visDate}, ${d.note}.`,
    first: (d) => `Dengan demikian, ${d.firstDate} adalah 1 ${d.month} menurut kalender Falak, sebagaimana ditunjukkan dalam video terlampir.`,
    firstSplit: (d) => `Dengan demikian, ${d.firstDate} adalah 1 ${d.month} menurut kalender hisab Falak, sedangkan awal bulan berdasarkan rukyat diperkirakan jatuh pada ${d.sightFirst}, sebagaimana ditunjukkan dalam video terlampir.`,
    xSight: (d) => ` (perkiraan rukyat: ${d.sightShort})`,
    respect: 'Kami menghormati pengumuman resmi setiap negara berdasarkan rukyatul hilal.',
    download: '📲 Unduh Falak:',
    bio: '📲 Link unduhan ada di bio',
    pro: 'Dari mesin perhitungan astronomi aplikasi Falak:',
    x: (d) => `🌙 Lahirnya hilal ${d.month} ${d.year} H: ${d.conjShort} ${d.conjTime} waktu Mekkah.\n1 ${d.month} (kalender Falak): ${d.firstShort}${d.sightX}.\nIkuti pengumuman resmi di negara Anda.`,
    ytTitle: (d) => `Lahirnya Hilal ${d.month} ${d.year} H – Waktu Mekkah | Aplikasi Falak`,
    pinTitle: (d) => `Jadwal lahirnya hilal ${d.month} ${d.year} H dan awal bulan`,
    tags: (m) => ['#Falak', `#Hilal${camel(m)}`, '#KalenderHijriah', '#Astronomi', '#RukyatulHilal'],
  },
  ur: {
    main: (d) => `🌙 فلک ایپ کے درست فلکیاتی حساب کے مطابق، ان شاء اللہ ${d.month} ${d.year} ہجری کا ہلال ${d.conjDate} کو مکہ مکرمہ کے وقت کے مطابق ${d.conjTime} پیدا ہوگا۔`,
    vis: (d) => `مکہ مکرمہ سے ہلال کی پہلی ممکنہ رویت ${d.visDate} کی شام کو ہوگی، ${d.note}۔`,
    first: (d) => `اس طرح فلک کیلنڈر کے مطابق ${d.firstDate} کو یکم ${d.month} ہوگی، جیسا کہ منسلک ویڈیو میں دکھایا گیا ہے۔`,
    firstSplit: (d) => `اس طرح فلک کے حسابی کیلنڈر کے مطابق ${d.firstDate} کو یکم ${d.month} ہوگی، جبکہ رویت کی بنیاد پر مہینے کا آغاز ${d.sightFirst} کو متوقع ہے، جیسا کہ منسلک ویڈیو میں دکھایا گیا ہے۔`,
    xSight: (d) => ` (متوقع رویت کے مطابق: ${d.sightShort})`,
    respect: 'ہم ہر ملک میں رویتِ ہلال کی بنیاد پر ہونے والے سرکاری اعلان کا احترام کرتے ہیں۔',
    download: '📲 فلک ڈاؤن لوڈ کریں:',
    bio: '📲 ڈاؤن لوڈ لنک بائیو میں',
    pro: 'فلک ایپ کے فلکیاتی حساب کے انجن سے:',
    x: (d) => `🌙 ${d.month} ${d.year} ہجری کا ہلال: ${d.conjShort}، مکہ کے وقت ${d.conjTime}۔\nیکم ${d.month} (فلک کیلنڈر): ${d.firstShort}${d.sightX}۔\nاپنے ملک کے سرکاری اعلان کی پیروی کریں۔`,
    ytTitle: (d) => `${d.month} ${d.year} ہجری کا ہلال – مکہ کا وقت | فلک ایپ`,
    pinTitle: (d) => `${d.month} ${d.year} ہجری: ہلال کی پیدائش اور مہینے کا آغاز`,
    tags: (m) => ['#فلک', `#${m.replace(/\s+/g, '_')}`, '#ہلال', '#اسلامی_کیلنڈر', '#رویت_ہلال'],
  },
};

function camel(s) {
  return s.split(/[^A-Za-z]+/).filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join('');
}

const fmt = (lang, date, opts) => new Intl.DateTimeFormat(LOCALES[lang], {
  calendar: 'gregory', numberingSystem: 'latn', ...opts,
}).format(date);

const dayOnly = (ymd) => {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d, 12));
};

function meccaTime(lang, date) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    .formatToParts(date);
  const h = Number(parts.find((p) => p.type === 'hour').value);
  const mm = parts.find((p) => p.type === 'minute').value;
  const h12 = ((h + 11) % 12) + 1;
  if (lang === 'id') return `pukul ${String(h).padStart(2, '0')}.${mm}`;
  if (lang === 'en') return `${h12}:${mm} ${h < 12 ? 'AM' : 'PM'}`;
  if (lang === 'ar') return `${h12}:${mm} ${h < 12 ? 'صباحاً' : 'مساءً'}`;
  const period = h < 12 ? 'صبح' : h < 16 ? 'دوپہر' : h < 19 ? 'شام' : 'رات';
  return `${period} ${h12}:${mm}`;
}

export function monthName(data, lang) {
  if (lang === 'ar') return data.month_name_ar;
  if (lang === 'en') return data.month_name_en;
  return (lang === 'id' ? MONTHS_ID : MONTHS_UR)[data.hijri_month - 1];
}

export function buildPosts(data, lang, links) {
  const t = T[lang];
  const conj = new Date(data.conjunction_utc);
  const long = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
  const short = { weekday: 'long', day: 'numeric', month: 'long' };
  const month = monthName(data, lang);
  const first = data.first_day_gregorian ? dayOnly(data.first_day_gregorian) : null;
  const d = {
    month,
    year: data.hijri_year,
    conjDate: fmt(lang, conj, { ...long, timeZone: TZ }),
    conjShort: fmt(lang, conj, { ...short, timeZone: TZ }),
    conjTime: meccaTime(lang, conj),
    utcTime: new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(conj),
    firstDate: first ? fmt(lang, first, { ...long, timeZone: 'UTC' }) : '',
    firstShort: first ? fmt(lang, first, { ...short, timeZone: 'UTC' }) : '',
    visDate: data.visibility_date ? fmt(lang, dayOnly(data.visibility_date), { ...short, timeZone: 'UTC' }) : '',
    note: (VIS_NOTES[data.visibility_status] || {})[lang],
  };
  const hasVis = Boolean(d.visDate && d.note);
  // Calculated calendar starts on/before the sighting evening: name both dates.
  const split = Boolean(first && data.visibility_date && data.first_day_gregorian <= data.visibility_date);
  const sight = split ? new Date(dayOnly(data.visibility_date).getTime() + 86400000) : null;
  d.sightFirst = sight ? fmt(lang, sight, { ...long, timeZone: 'UTC' }) : '';
  d.sightShort = sight ? fmt(lang, sight, { ...short, timeZone: 'UTC' }) : '';
  d.sightX = split ? t.xSight(d) : '';
  const body = [t.main(d), hasVis ? t.vis(d) : null, split ? t.firstSplit(d) : t.first(d), t.respect].filter(Boolean).join('\n');
  const tags = t.tags(month);
  const stores = `${t.download}\nGoogle Play: ${links.google}\nAppGallery: ${links.huawei}`;
  return {
    x: `${t.x(d)}\n${links.about}\n${tags.slice(0, 2).join(' ')}`,
    youtube: { title: t.ytTitle(d).slice(0, 100), description: `${body}\n\n${stores}\n\n${tags.slice(0, 3).join(' ')} #Shorts` },
    instagram: `${body}\n\n${t.bio}\n\n${tags.join(' ')}`,
    pinterest: { title: t.pinTitle(d).slice(0, 100), description: `${body}\n\n${tags.slice(0, 3).join(' ')}`.slice(0, 500), link: links.about },
    linkedin: `${t.pro}\n\n${body}\n\n${stores}\n\n${tags.slice(0, 3).join(' ')}`,
    facebook: `${body}\n\n${stores}\n\n${tags.join(' ')}`,
  };
}

// X counts every link as 23 characters.
export const xLength = (text) => text.replace(/https?:\/\/\S+/g, 'x'.repeat(23)).length;
